import moment from 'moment';
import jwt_decode from 'jwt-decode';

export function getTimeToExpire() {
  const token = localStorage.getItem('QUSER');
  try {
    const decoded = jwt_decode(token);
    let expire = decoded.exp;
    expire = moment.unix(expire);
    if (expire.isAfter()) {
      return moment(expire).subtract(moment()).format('mm:ss');
    }
  } catch (err) {
    console.error('invalid token');
  }
  return '0:00';
}

export function getRole() {
  try {
    const token = localStorage.getItem('QUSER');
    const decoded = jwt_decode(token);
    return decoded.aud;
  } catch (err) {
    console.error('invalid token');
    return '';
  }
}
